/**
 * DAI NHAP EMAIL — phan JS (10/10/2026 · phien 46).
 *
 * VI SAO CO FILE NAY: khach de lai email xong phai THAY MA NGAY tren man hinh.
 * (Du lieu 28.674 chien dich popup 2026: co ma giam gia doi duoc 1,46% vs 0,75% khi khong co;
 *  cau "check your inbox" la cau te nhat — phan lon don dau tien chot trong 24 gio dau.)
 *
 * File nay lam 3 viec nho:
 *   1) Bam "Copy"              => chep ma (co duong lui cho trinh duyet cu / trang http)
 *   2) Doi chu nut 2 giay      => "Copied" (de khach biet da chep duoc)
 *   3) Luu ma vao localStorage => ngan keo gio (bamboove-cart-drawer.js) biet khach co ma
 */
const KHOA_MA = 'bamboove-ma-nguoi-moi';

/** Chep chu vao bo nho tam — uu tien API moi, khong co thi lui ve execCommand */
function chepChu(chu) {
  if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(chu);
  return new Promise((xong, loi) => {
    const o = document.createElement('textarea');
    o.value = chu;
    o.setAttribute('readonly', '');
    o.style.position = 'fixed';
    o.style.opacity = '0';
    document.body.appendChild(o);
    o.select();
    try {
      document.execCommand('copy') ? xong() : loi(new Error('copy that bai'));
    } catch (e) {
      loi(e);
    } finally {
      o.remove();
    }
  });
}

/* 3) Luu ma lai cho ngan keo gio */
const khoiMa = document.querySelector('[data-bb-ma]');
if (khoiMa?.dataset.bbMa) {
  try {
    localStorage.setItem(KHOA_MA, khoiMa.dataset.bbMa);
  } catch {
    /* trinh duyet chan localStorage */
  }
}

/* 1+2) Nut Copy */
document.addEventListener('click', async (ev) => {
  const nut = ev.target instanceof Element ? ev.target.closest('[data-bb-chep]') : null;
  if (!nut) return;
  ev.preventDefault();

  const khoi = nut.closest('[data-bb-ma]');
  const ma = khoi?.dataset.bbMa || khoi?.querySelector('[data-bb-ma-so]')?.textContent?.trim() || '';
  if (!ma) return;

  const chuCu = nut.textContent;
  try {
    await chepChu(ma);
    nut.textContent = 'Copied';
    nut.classList.add('is-chep');
  } catch {
    nut.textContent = 'Copy failed';
  }
  setTimeout(() => {
    nut.textContent = chuCu;
    nut.classList.remove('is-chep');
  }, 2000);
});
